import React from 'react'

type Props = {
  children: React.ReactNode
}

const ListCardActions: React.FC<Props> = React.memo(({ children }) => (
  <div className="d-flex align-items-center ml-auto">{children}</div>
))

ListCardActions.displayName = 'ListCardActions'

export default ListCardActions
